import { FC, useState } from 'react';
import styled from 'styled-components';
import BadgesWindow from './BadgesWindow';
import { badgesConfig } from './badgesConfig';
import Badge, { BadgeInfo } from './Badge';

const Container = styled.div`
  padding: 5px;
  background: rgb(95, 186, 242);
  background: linear-gradient(0deg, rgba(95, 186, 242, 1) 0%, rgba(64, 157, 226, 1) 100%);
  grid-area: badges;
`;

const Title = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[1000]};
    font-size: 1.125rem;
    font-weight: ${type.weight.regular};
    margin-left: 15px;

  `;
});

const ShowAll = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    text-decoration: underline;
    cursor: pointer;
    font-size: ${type.size.small};
    color: ${color.grayscale[1000]};
    text-align: center;
  `;
});

type Badge = BadgeInfo | null;

interface BadgesWidgetProps {
  currentStep: number;
}

const BadgesWidget: FC<BadgesWidgetProps> = ({ currentStep }) => {
  const [showAllBadges, setShowAllBadges] = useState(false);

  const getUnlockedBadges = (level: number) => {
    const unlockedBadges = [];
    let latestBadge: Badge = null;

    for (const index in badgesConfig) {
      const currentBadge = badgesConfig[index];

      if (level >= currentBadge.unlock_level) {
        unlockedBadges.push(currentBadge);

        if (!latestBadge || latestBadge.unlock_level < currentBadge.unlock_level) {
          latestBadge = currentBadge;
        }
      }
    }

    return {
      latest_badge: latestBadge,
      unlocked_badges: unlockedBadges,
    };
  };

  const level = Math.floor(currentStep / 5) + 1;
  const unlockedBadges = getUnlockedBadges(level);

  return (
    <Container>
      <Title>Badges</Title>

      {unlockedBadges.latest_badge && <Badge badgeInfo={unlockedBadges.latest_badge} current={true}></Badge>}

      <ShowAll onClick={() => setShowAllBadges(true)}>Show all badges</ShowAll>

      {showAllBadges && (
        <BadgesWindow hideFunction={() => setShowAllBadges(false)} unlockedBadges={unlockedBadges.unlocked_badges} />
      )}
    </Container>
  );
};

export default BadgesWidget;
